export enum FieldUsageId {
	None = 1,
	Active,
	DeprecateCandidate,
	Hidden
}
